import React from 'react';
import styled from "styled-components";
import Bujny from "../../Assets/bujny.svg"
import Ziemiszewska from "../../Assets/ziemiszewska.svg"
import Hansen from "../../Assets/hansen.svg"
import Pregowski from "../../Assets/pregowski.svg";
import Bottema from "../../Assets/bottema.svg";
import Byoung from "../../Assets/byoung.svg";
import Susan from "../../Assets/susan.svg";
import Barnabas from "../../Assets/barnabas.svg";
import Violetta from "../../Assets/violetta.svg";


const Jury = () => {
    return (
        <Wrapper>
            <Content>
                <h1>Jury Finałowe </h1>
                <JuryPair>
                    <JuryImg>
                        <img src={Bujny} alt={"Jarek Bujny"}/>
                    </JuryImg>
                    <JuryText>
                        <h2>Jarek Bujny</h2>
                        <p>Pomysłodawca konkursu. Projektant grafik, artysta wizualny, kurator, wykładowca.</p>
                        <p> Twórca plakatów o tematyce społecznie zaangażowanej. Bada komunikację wizualną w obszarach
                            napięć społecznych oraz problemów zdrowotnych. Prowadzi Pracownię Projektowania Graficznego
                            na Wydziale Sztuki Uniwersytetu Warmińsko-Mazurskiego. Jest finalistom wielu konkursów
                            plakatu, wyróżniony m.in. na; Poster Bolivia Bienniale 2019 BiceBi 2019, PlakatFest 2018 w
                            Chorzowie, Taipei International Design Award 2016, Graphis Protest Posters 2, Satyrykon
                            2022. Jego plakaty były prezentowane na całym świecie w Wenezueli, Meksyku, Chinach,
                            Francji, Niemczech, Hiszpanii, Portugalii, Turcji, USA itd.</p>
                        <p> Realizował warsztaty z projektowania graficznego ze studentami w Niemczech, Izraelu,
                            Finlandii i na Litwie. Kurator wystaw w Kanadzie, Francji, Niemczech. Stypendysta DAAD.
                            Prowadzi studio graficzne www.bujny.com realizując projekty dla firm oraz instytucji kultury
                            oraz wydawnictw.</p>
                    </JuryText>
                </JuryPair>
                <JuryPair>
                    <JuryImg>
                        <img src={Ziemiszewska} alt={"Agnieszka Ziemiszewska"}/>
                    </JuryImg>
                    <JuryText>
                        <h2>Agnieszka Ziemiszewska</h2>
                        <p>Graficzka, edukatorka i kuratorka sztuki</p>
                        <p> Jej prace były prezentowane na całym świecie. Laureatka nagród i wyróżnień. Obecnie jest
                            profesorem na Wydziale Sztuki Nowych Mediów w Polsko-Japońskiej Akademii Technik
                            Komputerowych w Warszawie.</p>
                        <p> Wykładała i prowadziła warsztaty na wielu międzynarodowych uniwersytetach.</p>
                        <p> Jurorka w krajowych i międzynarodowych konkursach i imprezach graficznych. Była również
                            kuratorem i współorganizatorem wielu wystaw w Polsce i za granicą. Portfolio online:
                            www.ziemi.art.pl</p>
                    </JuryText>
                </JuryPair>
                <JuryPair>
                    <JuryImg>
                        <img src={Hansen} alt={"Rikke Hansen"}/>
                    </JuryImg>
                    <JuryText>
                        <h2>Rikke Hansen</h2>
                        <p>Projektantka graficzna i edukatorka. Od kilku lat zajmuje się rozwojem produktu, brandingiem
                            i doradztwem dla firm i organizacji. Obecnie wykłada różne kursy projektowania w różnych
                            szkołach projektowania i uniwersytetach w Danii i za granicą. Pracuje nad projektami
                            rozwojowymi i prowadzi badania w tym zakresie. Ma własne studio projektowe zajmujące się
                            drukiem i projektowaniem cyfrowym, jest także właścicielką warsztatu letterpress.
                            Wiceprzewodnicząca Duńskiego Stowarzyszenia Book Crafting. Mianowana przez Ministerstwo
                            Szkolnictwa Wyższego i Nauki zewnętrznym egzaminatorem w zakresie wyższych pro- gramów
                            kształcenia artystycznego.</p>
                        <p> Juror na14th BICM, International Poster Biennial Mexico. Cyprus Poster Triennial. Graphis
                            Talent Award. Ukrainian Design: The Very Best Of. International Poster Biennial Lublin.
                            India’s Best Design Award, BI- CeBé International Poster Biennial Bolivia 2021. 11th Poster
                            Triennial Trnava, Ecuador Poster Biennial, TISDC Taiwan International Student Design
                            Competition.</p>
                        <p> Laureatka COFOD Excelence Award winner. Graphis Platinum, Gold i Silver Awards. China
                            Internatio- nal Poster Biennial Silver Award, MutzurWut, Międzynarodowe Biennale Plakatu
                            Lublin 1st Prize Award. KIDC Excellence Award. Danish Art Foundation Work Grant.</p>
                        <p>Wystawia, wykłada i prowadzi warsztaty w Europie, na Bliskim Wschodzie, w Azji i Ameryce.
                            Więcej informacji www.wheelsandwaves.dk</p>
                    </JuryText>
                </JuryPair>
                <JuryPair>
                    <JuryImg>
                        <img src={Pregowski} alt={"Nikodem Pręgowski"}/>
                    </JuryImg>
                    <JuryText>
                        <h2>Nikodem Pręgowski</h2>
                        <p>Grafik, twórca plakatów i ilustracji. Absolwent Uniwersytetu Mikołaja Kopernika, gdzie jako
                            kierownik Katedry Projektowania Graficznego uczy studentów m.in. projektowania książek,
                            ilustracji, a także liternictwa i typografii. Założyciel wydawnictwa „Na przykład”. Laureat
                            kilkudziesięciu nagród z zakresu plakatu. Jego prace pokazywane były, m.in.: w Belgii, na
                            Białorusi, w Holandii, Chinach, Czechach, Ekwadorze, Estonii, Finlandii, Iranie, Peru,
                            Rosji, Słowacji, Turcji, USA.</p>
                    </JuryText>
                </JuryPair>
                <JuryPair>
                    <JuryImg>
                        <img src={Bottema} alt={"Joost Bottema"}/>
                    </JuryImg>
                    <JuryText>
                        <h2>Joost Bottema</h2>
                        <p>Wykładowca, projektant graficzny, autor.</p>
                        <p> Profesor, kierownik Katedry Komunikacji Wizualnej w Merz Akademie, Stuttgart, Niemcy.
                            Doświadczony projektant w zakresie klasycznego projektowania graficznego i platform
                            wydawniczych online (web to print).</p>
                        <p> Publikuje powieści i artykuły, w których design, sztuka, wzór i struktura są umieszczone w
                            szerokiej per- spektywie. Mieszka w Amsterdamie.
                        </p>
                    </JuryText>
                </JuryPair>

                <h1>Jury Preselekcyjne</h1>

                <JuryPair>
                    <JuryImg>
                        <img src={Byoung} alt={"Byoung Il Sun"}/>
                    </JuryImg>
                    <JuryText>
                        <h2>Byoung Il Sun</h2>
                        <p>Od 1995 roku jest profesorem w dziedzinie projektowania informacji wizualnej na Uniwersytecie
                            Namseoul. Jest absolwentem projektowania komunikacji wizualnej na Uniwersytecie Hongik,
                            gdzie uzyskał tytuł magistra w 2005 r. (Ph., D. degree in Arts). Byoungil-Sun otrzymał
                            różne nagrody, takie jak Presidential Award za wkład w rozwój designu przy rządzie Republiki
                            Korei. International Awards Golden Bee, Graphis, Taiwan, Red dot, Gdie, Ekoplakt,
                            Information war, World without violence, Poster for tomorrow oraz 160 int’l. Zasiadał
                            również w jury wielu międzynarodowych konkursów projektowych m.in. na Ukrainie, w Norwegii,
                            Słowacji, Białorusi, Lublinie, Francji, Iranie, Chinach, Turcji, Korei. Brał udział w
                            wystawach indywidualnych, zarówno w Korei jak i za granicą (zwłaszcza na Węgrzech, w
                            Rumunii, Londynie, Canberze, Osace, Akicie, Pekinie, Turcji, Indonezji. Polsce).</p>
                        <p> W latach był przewodniczącym Hongik Communication Design Forum w 2011 roku oraz Korea
                            Institute</p>
                        <p> of Cultural Product & Design w 2005 roku. Kolekcje plakatów: Library of congress washington
                            DC, USA, Moscow Golden Bee, Colorado University, Lahti, Chaumont, Toyama, Mexico, Beijing,
                            4th Block kharkov, Modium museum Seoul, Iang gallery Seoul, Shunzen Museum China. Tajwan
                            centrum cpc.</p>
                    </JuryText>
                </JuryPair>
                <JuryPair>
                    <JuryImg>
                        <img src={Susan} alt={"Susana Machicao Pacheco"}/>
                    </JuryImg>
                    <JuryText>
                        <h2>Susana Machicao Pacheco</h2>
                        <p>Boliwijska graficzka w obszarze komunikacji wizualnej z ponad 20-letnim doświadczeniem.</p>
                        <p> Dyrektorka Biennale Plakatu w Boliwii BICeBé, regionalna koordynatorka Tipos Latinos
                            Biennale Typografii Latynoamerykańskiej. Założycielka i dyrektor LATAM_D, przestrzeni
                            skupiającej projektantów mody, przemysłu, produktu i grafiki z Ameryki Łacińskiej.
                            Założycielka i dyrektorka społeczności Graphic Designers Bolivia oraz twórczyni
                            międzynarodowego projektu Mujeres Diseñadoras (Kobiety Projektantki).</p>
                        <p> W 2016 roku została uznana za Design Professional Uniwersytetu w Palermo w Latin American
                            Forum of Design Schools, Ambasador w Radzie Ambasadorów Designu Ameryki Łacińskiej
                            Uniwersytetu w Palermo w Argentynie, Członek Komitetu Doradczego BIAPE. Barcelona
                            International Annual Poster Exhibition, Honorowy Członek Międzynarodowego Biennale Plakatu w
                            Warszawie, Associate Member of the China International Design Educator Association C-IDEA,
                            Founding Member of CAMEBOL Chamber of Women Entrepreneurs of Bolivia.</p>
                        <p> Była międzynarodowym jurorem oraz prelegentem i prowadzącą warsztaty na różnych krajowych i
                            międzynarodowych imprezach. Prowadziła również warsztaty na biennale i festiwalach designu
                            w takich krajach jak m.in. Francja, Meksyk, Peru, Ekwador, Argentyna, Ukraina, Kolumbia,
                            Paragwaj. Jej prace brały udział w kilku wystawach i biennale na całym świecie.</p>
                    </JuryText>
                </JuryPair>
                <JuryPair>
                    <JuryImg>
                        <img src={Barnabas} alt={"Barnabas Wettnon"}/>
                    </JuryImg>
                    <JuryText>
                        <h2>Barnabas Wettnon</h2>
                        <p>Profesor Barnabas Wetton jest kierownikiem działu komunikacji w Designskolen Kolding w
                            Danii.</p>
                        <p> Po ukończeniu studiów artystycznych w Wielkiej Brytanii pracował przy projekcie budowy mostu
                            w Peru, pracował dla BBC World Service i namalował serię billboardów w Londynie. Fascynują
                            go przestrzenie tworzone między słowami, typografią i obrazami oraz sposoby angażowania
                            widzów w wizualne i ucieleśnione narracje. Dwa z jego projektów dydaktycznych są częścią
                            stałej kolekcji w MoMA w Nowym Jorku, a wraz z Rikke Hansenem odegrał kluczową rolę w rozwoju technik projektowania,
                            aby przełamać polityczne bariery między Izraelem a Palestyną.
                        </p>
                    </JuryText>
                </JuryPair>
                <JuryPair>
                    <JuryImg>
                        <img src={Violetta} alt={"Violetta Kulikowska-Parkasiewicz"}/>
                    </JuryImg>
                    <JuryText>
                        <h2>Violetta Kulikowska-Parkasiewicz</h2>
                        <p>Dyrektor Instytutu Sztuk Pięknych Uniwersytetu Warmińsko-Mazurskiego w Olsztynie, profesor
                            uczelni prowadzi pracownię intermediów. Dyplom zrealizowała w zakresie grafiki warsztatowej,
                            zajmuje się rysunkiem artystycznym. Laureatka wielu konkursów artystycznych: Triennale
                            Polskiego Rysunku Współczesnego – Lubaczów, Międzynarodowe Biennale Rysunku w Pilznie,
                            Międzynarodowy Konkurs Rysunku, Wrocław, Kaliskie Biennale Rysunku i Grafiki „Próba1”,
                            Triennale Sztuki Sacrum w Częstochowie, dwukrotna laureatka Grand Prix Olsztyńskiego
                            Biennale Sztuki - O Medal Prezydenta, laureatka Grand Prix na Ogólnopolskim Salonie
                            Zimowym w 2022 roku.</p>
                        <p> Prezes Fundacji Wyłom. Członek Warmińsko-Mazurskiego Towarzystwa Zachęty Sztuk Pięknych w
                            Olsztynie. Autorka kilkunastu wystaw indywidualnych.</p>
                    </JuryText>
                </JuryPair>
                <JuryPair>
                    <JuryImg>
                        <img src={Bujny} alt={"Jarek Bujny"}/>
                    </JuryImg>
                    <JuryText>
                        <h2>Jarek Bujny</h2>
                        <p>Pomysłodawca konkursu. Projektant grafik, artysta wizualny, kurator, wykładowca.</p>
                        <p> Twórca plakatów o tematyce społecznie zaangażowanej. Bada komunikację wizualną w obszarach
                            napięć społecznych oraz problemów zdrowotnych. Prowadzi Pracownię Projektowania Graficznego
                            na Wydziale Sztuki Uniwersytetu Warmińsko-Mazurskiego. Jest finalistom wielu konkursów
                            plakatu, wyróżniony m.in. na; Poster Bolivia Bienniale 2019 BiceBi 2019, PlakatFest 2018 w
                            Chorzowie, Taipei International Design Award 2016, Graphis Protest Posters 2, Satyrykon
                            2022. Jego plakaty były prezentowane na całym świecie w Wenezueli, Meksyku, Chinach,
                            Francji, Niemczech, Hiszpanii, Portugalii, Turcji, USA itd.</p>
                        <p> Realizował warsztaty z projektowania graficznego ze studentami w Niemczech, Izraelu,
                            Finlandii i na Litwie. Kurator wystaw w Kanadzie, Francji, Niemczech. Stypendysta DAAD.
                            Prowadzi studio graficzne www.bujny.com realizując projekty dla firm oraz instytucji kultury
                            oraz wydawnictw.</p>
                    </JuryText>
                </JuryPair>
            </Content>
        </Wrapper>
    )
}

export default Jury

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 12% 10% 0 10%;
  position: relative;

  h1 {
    font-family: Lato;
    color: #E44432;
    font-weight: 800;
    margin-top: 10px;
    padding: 10px;
    border-radius: 50px;
    text-transform: uppercase;

    @media(max-width: 768px){
      text-align: center;
    }
  }
`

const Content = styled.div`
  display: flex;
  flex-direction: column;
  width: 700px;
  
  @media(max-width: 768px){
    width: 100vw;
  }
`

const JuryPair = styled.div`
  display: flex;
  flex-direction: Row;
  align-items: center;
  width: 100%;
  height: auto;
  margin-bottom: 20px;

  @media(max-width: 768px){
    flex-direction: column;
  }
`

const JuryImg = styled.div`
  width: 280px;

  img {
    max-width: 280px;
    @media(max-width: 768px){
      width: 220px;
    }
  }

  @media(max-width: 768px){
    width: 240px;
  }
`

const JuryText = styled.div`
  max-width: 400px;
  margin-left: 20px;

  h2 {
    font-family: Lato;
    font-weight: 400;
    font-size: 24px;
    color: black;
  }

  p {
    font-family: Lato;
    font-weight: 400;
    font-size: 14px;
    line-height: 1.5;
    color: black;
  }

  @media(max-width: 768px){
    max-width: 350px;
    padding: 0 10px;
  }
`

